import { TableCells, BankAccountView } from 'models';
import { formatNum } from 'utils';

export const investorBankAccounts: TableCells<BankAccountView>[] = [
  {
    id: 'Number',
    type: 'string',
    label: '#portal.investor.bankaccount.number',
  },
  {
    id: 'Operator.Name',
    type: 'string',
    label: '#portal.investor.bankaccount.operator',
  },
  {
    id: 'Balance.Value',
    type: 'number',
    label: '#portal.investor.bankaccount.balance',
    render: (bankAccount) =>
      `${formatNum(bankAccount.Balance?.Value)} ${
        bankAccount.Balance?.Symbol || '€'
      }`,
  },
  {
    id: 'BalanceDate',
    type: 'date',
    label: '#portal.investor.bankaccount.balancedate',
  },
];
